/**
 * 分页条默认设置
 */
const pagination = {
  current: 1,
  total: 0,
  pageSizeOptions: ['5', '10', '20', '50'],
  pageSize: 10,
  defaultPageSize: 10,
  showQuickJumper: true,
  showSizeChanger: true,
  showTotal: function (total, range) {
    return '当前显示第' + range[0] + '-' + range[1] + '条, 共 ' + total + ' 条数据'
  }
};

const scriptUrl ='//at.alicdn.com/t/font_2725410_n0jswqoave.js';

const oauthUrl = process.env.VUE_APP_OAuth2Url;

//const wsDUrl ='ws://localhost:8088/gpws/doctor';

const wsDUrl =process.env.VUE_APP_WSUrl+"/doctor";

//const wsEUrl ='ws://localhost:8088/gpws/expert';

const wsEUrl =process.env.VUE_APP_WSUrl+'/expert';

export default {
  pagination,
  scriptUrl,
  oauthUrl,
  wsDUrl,
  wsEUrl
}